var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c("div", { staticClass: "siderbar-menu-search" }, [
            !_vm.isCollapse
              ? _c(
                  "div",
                  {},
                  [
                    _c("el-input", {
                      staticClass: "sidebar-search-input",
                      attrs: {
                        placeholder: "搜索菜单,回车确认",
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearchMenu($event)
                        },
                      },
                      model: {
                        value: _vm.searchMenuKeywordText,
                        callback: function ($$v) {
                          _vm.searchMenuKeywordText = $$v
                        },
                        expression: "searchMenuKeywordText",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "background-color": _vm.variables.menuBg,
                "text-color": _vm.variables.menuText,
                "unique-opened": true,
                "active-text-color": _vm.variables.menuActiveText,
                "collapse-transition": false,
                mode: "vertical",
              },
            },
            [
              _vm.isCollapse
                ? _c("div", { staticClass: "menu-wrapper" }, [
                    _c("li", { staticClass: "el-submenu" }, [
                      _c(
                        "div",
                        {
                          staticClass: "submenu-title sidebar-search-item",
                          on: { click: _vm.toggleSideBarHandle },
                        },
                        [_c("i", { staticClass: "el-icon-search" })]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._l(_vm.filteredRoutes, function (route) {
                return _vm.filteredRoutes.length > 0
                  ? _c("sidebar-item", {
                      key: route.path,
                      attrs: { item: route, "base-path": route.path },
                    })
                  : _vm._e()
              }),
              _vm._l(_vm.permission_routes, function (route) {
                return _vm.filteredRoutes.length === 0
                  ? _c("sidebar-item", {
                      key: route.path,
                      attrs: { item: route, "base-path": route.path },
                    })
                  : _vm._e()
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }